export const PATHS = {
  ROOT: 'certificates',
  getOneById: (id: number) => `${PATHS.ROOT}/${id}`,
  getAllByResumeId: (resumeId: number) => `resume/${resumeId}/${PATHS.ROOT}`,
};
